import React, { useRef, useState, useEffect } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';
import { discoverGalleryPhotos, mergeGalleryPhotos } from '../utils/photoDiscovery';

const Wine = () => {
  const galleryRef = useRef();
  const [photos, setPhotos] = useState(galleryData.wine || []);

  // Discover additional photos from S3
  useEffect(() => {
    const loadDiscoveredPhotos = async () => {
      try {
        const discoveredPhotos = await discoverGalleryPhotos('wine');
        const mergedPhotos = mergeGalleryPhotos(galleryData.wine || [], discoveredPhotos);
        setPhotos(mergedPhotos);
      } catch (error) {
        console.warn('Could not load discovered photos:', error);
        setPhotos(galleryData.wine || []);
      }
    };

    loadDiscoveredPhotos();
  }, []);

  return (
    <section id="wine" className="section wine-section">
      <div className="section-header">
        <img src="/images/wine.png" alt="Wine" className="section-icon" />
        <h1>Wine</h1>
      </div>

      <div className="wine-content">
        <p>
          Wine making is a tradition that runs deep in our family. From the vineyards of Italy to our home in Connecticut, 
          the art of creating fine wine has been passed down through generations.
        </p>
      </div>

      {/* Wine Gallery - Moved to top */}
      <div className="futbol-gallery-section">
        <Gallery 
          ref={galleryRef} 
          images={photos} 
          sectionName="Wine is in our blood"
        />
      </div>
    </section>
  );
};

export default Wine;